import(/* webpackMode: "eager", webpackExports: ["InvoiceEditor"] */ "/app/src/components/features/InvoiceEditor.tsx");
